import axios from "axios";

const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL;

export const fetchPromoStoreUserBudgets = async (storeId, instanceUniqueId, query = {}) => {
  const response = await axios.get(`${BASE_URL}/promostores/${storeId}/user-budgets`, {
    params: { ...query, instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const fetchPromoStoreUserPoints = async (storeId, instanceUniqueId, query = {}) => {
  const response = await axios.get(`${BASE_URL}/promostores/${storeId}/user-points`, {
    params: { ...query, instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const previewPromoStoreEmployeeImport = async (storeId, instanceUniqueId, file) => {
  const form = new FormData(); form.append("file", file);
  const response = await axios.post(`${BASE_URL}/promostores/${storeId}/employee-import/preview`, form, {
    params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};
export const applyPromoStoreEmployeeImport = async (storeId, instanceUniqueId, token) => {
  const response = await axios.post(`${BASE_URL}/promostores/${storeId}/employee-import/apply`, { token }, {
    params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const fetchPromoStoreEmployees = async (storeId, instanceUniqueId, query = {}) => {
  const response = await axios.get(`${BASE_URL}/promostores/${storeId}/employee-directory`, {
    params: { ...query, instanceUniqueId },
    headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const fetchPromoStoreAddonCatalog = async () => {
  const response = await axios.get(`${BASE_URL}/promostores/addons/catalog`, {
    headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const fetchPromoStoreAddonRegistry = async () => {
  const response = await axios.get(`${BASE_URL}/promostores/addons/registry`, {
    headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const fetchPromoStoreAddonConnection = async (storeId, instanceUniqueId) => {
  const response = await axios.get(`${BASE_URL}/promostores/${storeId}/addon-connection`, {
    params: { instanceUniqueId },
    headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const patchPromoStoreAddonConnection = async (storeId, instanceUniqueId, key, patch) => {
  const response = await axios.patch(`${BASE_URL}/promostores/${storeId}/addon-connection/${encodeURIComponent(key)}`, patch, {
    params: { instanceUniqueId },
    headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const applyPromoStoreFinance = async (storeId, instanceUniqueId, body) => {
  const response = await axios.post(`${BASE_URL}/promostores/${storeId}/finance`, body, {
    params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") },
  });
  return response.data;
};

export const fetchPromoStoreProductDisplay = async (storeId, instanceUniqueId, productId) => {
  const response = await axios.get(`${BASE_URL}/promostores/${storeId}/product-display/${productId}`, { params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") } }); return response.data;
};
export const patchPromoStoreProductDisplay = async (storeId, instanceUniqueId, productId, patch) => {
  const response = await axios.patch(`${BASE_URL}/promostores/${storeId}/product-display/${productId}`, patch, { params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") } }); return response.data;
};
